<script lang="ts">
  import AdminView from "./AdminView.svelte";
  import IntroBlock from "./Block.svelte";
  import type { Operator } from "@/src/types/components/operators/Operator";
  import type { IntroProps } from "@/src/types/components/Intro";

  export let props: IntroProps;
  export let adminView: boolean = false;
  export let operator: Operator | undefined;
</script>

{#if adminView}
  <AdminView {props} />
{:else}
  <IntroBlock {props} {operator} />
{/if}
